export enum ClientApps {
  PPW = 'PPW',
  PBS = 'PBS',
}

export const MAX_BREADCRUMBS_RECORDS_COUNT = 50;

export enum BreadcrumbTypes {
  PPW = 'PUBLIC_WEB_BREADCRUMBS_TYPE',
  PBS = 'PBS_BREADCRUMBS_TYPE',
}

export enum PageNames {
  ALLPRODUCTS = 'ALLPRODUCTS',
  SITE = 'SITE',
  BUSINESS = 'BUSINESS',
  CATEGORY = 'CATEGORY',
  SUBCATEGORY = 'SUBCATEGORY',
  RANGE = 'RANGE',
  PRODUCT = 'PRODUCT',
}

export const {
  SITE,
  BUSINESS,
  CATEGORY,
  SUBCATEGORY,
  RANGE,
  PRODUCT,
  ALLPRODUCTS,
} = PageNames;

export const breadcrumbsLevels = {
  [BreadcrumbTypes.PPW]: [
    SITE,
    ALLPRODUCTS,
    BUSINESS,
    CATEGORY,
    SUBCATEGORY,
    RANGE,
    PRODUCT,
  ],
  [BreadcrumbTypes.PBS]: [
    ALLPRODUCTS,
    CATEGORY,
    SUBCATEGORY,
    RANGE,
    PRODUCT,
  ],
};
